"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueExcelField = void 0;
var ValueExcelField;
(function (ValueExcelField) {
    ValueExcelField["goldPreis"] = "Goldpreis";
    ValueExcelField["silberPreis"] = "Silberpreis";
    ValueExcelField["platinPreis"] = "Platinpreis";
    ValueExcelField["palladiumPreis"] = "Palladiumpreis";
    ValueExcelField["kalkulationsfaktorMinora"] = "Kalkulationsfaktor Minora";
    ValueExcelField["kalkulationsfaktorTw"] = "Kalkulationsfaktor Trauringwunder";
    ValueExcelField["kalkulationsfaktorCilorB2B"] = "Kalkulationsfaktor Cilor B2B";
    ValueExcelField["kalkulationsfaktorCilorB2C"] = "Kalkulationsfaktor Cilor B2C";
    ValueExcelField["kalkulationsfaktorSchmuckwunder"] = "Kalkulationsfaktor Schmuckwunder";
})(ValueExcelField = exports.ValueExcelField || (exports.ValueExcelField = {}));
//# sourceMappingURL=ValueExcelField.js.map